import { useEffect, useState } from 'react';
import Daily from '@daily-co/daily-js';
import { DailyProvider } from '@daily-co/daily-react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { getMeetingDetails } from '@/services/MeetingController';
import { VideoDaily } from './VideoDaily';

// const callObject = Daily.createCallObject();

export const VideoCallDaily = () => {
	const [incident, setIncident] = useState(null);
	const [userRole, setUserRole] = useState(null); // 'doctor' or 'patient'
	const [videoCallData, setVideoCallData] = useState(null);
	const [meetingToken, setMeetingToken] = useState(null);

	const [error, setError] = useState(false);

	const { videoEntranceToken } = useParams();

	useEffect(() => {
		const fetchMeetingDetails = async () => {
			try {
				const res = await getMeetingDetails(videoEntranceToken);
				console.log(res);
				setIncident(res?.incident);
				setVideoCallData(res?.videoCallData);
				setMeetingToken(res?.meetingToken);
				setError(res?.error);
				// callObject.join({ url: res.videoCallData?.url });
			} catch (err) {
				console.log('fetchMeetingDetails err:', err);
				setError(true);
			}
		};

		fetchMeetingDetails();
	}, [videoEntranceToken]);

	// const [callObject, setCallObject] = useState(null);
	// useEffect(() => {
	// 	if (callObject) {
	// 		return;
	// 	}
	// 	const call = Daily.createCallObject();
	// 	setCallObject(call);
	// 	call.join({ url: roomUrl });

	// 	return () => {
	// 		call.leave();
	// 	};
	// }, [roomUrl]);

	// useEffect(() => {
	// 	createRoom();
	// }, []);

	// const createRoom = async () => {
	// 	try {
	// 		const res = await axios.post(
	// 			'https://api.daily.co/v1/rooms',
	// 			{
	// 				name: 'room-name-2', // Optional (or use random)
	// 				properties: {
	// 					enable_chat: true,
	// 					exp: Math.floor(Date.now() / 1000) + 3600, // 1-hour expiry
	// 				},
	// 			},
	// 			{
	// 				headers: {
	// 					Authorization: `Bearer ${API_KEY}`,
	// 					'Content-Type': 'application/json',
	// 				},
	// 			},
	// 		);

	// 		console.log('Room created:', res.data.url);
	// 		if (res.data.url) {
	// 			setRoom(res.data.url);
	// 		}
	// 		return res.data.url;
	// 	} catch (err) {
	// 		console.log('createRoom err:', err);
	// 	}
	// };
	// !callObject ||
	console.log('ooo', error, typeof error);
	if (error) {
		return (
			<div className='self-center pt-20 text-center'>
				{typeof error === 'string' ? error : 'Something went wrong.'}
			</div>
		);
	}

	if (!videoCallData?.url || !meetingToken) return null;

	return (
		<DailyProvider>
			<VideoDaily videoCallData={videoCallData} incident={incident} meetingToken={meetingToken} />
		</DailyProvider>
	);
};
